import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { BehaviorSubject } from 'rxjs';


@Injectable({
    providedIn: 'root',
})
export class ToastrService {
    private readonly _notificationMessage$ = new BehaviorSubject<{}>({});
    readonly notificationMessage$ = this._notificationMessage$.asObservable();


    constructor(private messageService: MessageService) { }

    showSuccess = (msg: string, summary?) => {
        this.messageService.add({ key: 'tst', severity: 'success', summary: summary ? summary : 'Success', detail: msg });
        this._notificationMessage$.next({ msg: msg, status: 'success' });
    };

    showError = (msg: string) => {
        this.messageService.add({ key: 'tst', severity: 'error', summary: 'Error', detail: msg });
        this._notificationMessage$.next({ msg: msg, status: 'error' });
    };

    showWarning = (msg: string) => {
        this.messageService.add({ key: 'tst', severity: 'warn', summary: 'Warning', detail: msg });
        this._notificationMessage$.next({ msg: msg, status: 'warn' });
    };

    showInfo = (msg: string) => {
        this.messageService.add({ key: 'tst', severity: 'info', summary: 'Information', detail: msg });
        this._notificationMessage$.next({ msg: msg, status: 'info' });
    };
}
